// libraires
import React, { useState } from "react";

// styles
import styles from "./styles.module.scss";

// assets
import EyeClosed from "../../../../assets/images/register/eye-closed.svg";
import EyeOpen from "../../../../assets/images/register/eye-open.svg";

const Input = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <label className={styles.input}>
      <span>{props.label}</span>
      {/* {props.label} */}
      {props.icon && (
        <img
          src={!isOpen ? EyeClosed : EyeOpen}
          alt="eye icon"
          onClick={toggle}
        />
      )}
      <input
        {...props}
        type={props.icon ? (isOpen ? "text" : "password") : props.type}
      />
    </label>
  );
};

export default Input;
